import {
  defineCborSchema,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type ListHumanProxiesRequestPayload = {}

export const ListHumanProxiesRequestPayloadSchema: CborSchema<ListHumanProxiesRequestPayload> =
  defineCborSchema<ListHumanProxiesRequestPayload>({})
